/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Media_Location_LabelInputs */

const en_new_project_media_location_label = /** @type {(inputs: New_Project_Media_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media Location`)
};

const fr_new_project_media_location_label = /** @type {(inputs: New_Project_Media_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emplacement du media`)
};

const de_new_project_media_location_label = /** @type {(inputs: New_Project_Media_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medienstandort`)
};

const it_new_project_media_location_label = /** @type {(inputs: New_Project_Media_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizione dei media`)
};

const ru_new_project_media_location_label = /** @type {(inputs: New_Project_Media_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Медиа-местоположение`)
};

const es_new_project_media_location_label = /** @type {(inputs: New_Project_Media_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubicación de los medios`)
};

const zh_cn2_new_project_media_location_label = /** @type {(inputs: New_Project_Media_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`媒体位置`)
};

const ja_new_project_media_location_label = /** @type {(inputs: New_Project_Media_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアの場所`)
};

const hi_new_project_media_location_label = /** @type {(inputs: New_Project_Media_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मीडिया स्थान`)
};

const pt_pt2_new_project_media_location_label = /** @type {(inputs: New_Project_Media_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Localização da mídia`)
};

/**
* | output |
* | --- |
* | "Media Location" |
*
* @param {New_Project_Media_Location_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_media_location_label = /** @type {((inputs?: New_Project_Media_Location_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Media_Location_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_media_location_label(inputs)
	if (locale === "de") return de_new_project_media_location_label(inputs)
	if (locale === "it") return it_new_project_media_location_label(inputs)
	if (locale === "ru") return ru_new_project_media_location_label(inputs)
	if (locale === "es") return es_new_project_media_location_label(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_media_location_label(inputs)
	if (locale === "ja") return ja_new_project_media_location_label(inputs)
	if (locale === "hi") return hi_new_project_media_location_label(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_media_location_label(inputs)
	return en_new_project_media_location_label(inputs)
});